import { Component, Input } from '@angular/core';
import { ControlTemplate } from 'src/app/rent-module/components/form/entities/controlTemplate';


@Component({
  selector: 'app-rangeInput-control-value-view, [app-rangeInput-control-value-view]',
  templateUrl: './rangeInput-control-value-view.component.html',
  styleUrls: ['./rangeInput-control-value-view.component.scss']
})
export class RangeInputControlValueViewComponent {

  @Input() controlTemplate: ControlTemplate;

  constructor(
  ) {
  }

  public showSuffix(): boolean {
    return this.controlTemplate?.settings?.suffix;
  }

}
